import { Location, NavigateFunction } from 'react-router-dom';
import { Survey } from '../interfaces/survey.interface';
import { BestPractice } from '../interfaces/bestPractice.interface';
import { Question } from '../interfaces/question.interface';
import { Assessment } from '../interfaces/assessment.interface';
import { Topic } from '../interfaces/topic.interface';
import { Domain } from '../interfaces/domain.interface';

const CLOUDFRONT_BASE = process.env.REACT_APP_CLOUDFRONT_BASE;
const CLOUDFRONT_PREFIX = `${CLOUDFRONT_BASE}`;

export const COUNTRIES_JSON = `${CLOUDFRONT_PREFIX}/countries.json`;
export const STATES_JSON = `${CLOUDFRONT_PREFIX}/states.json`;
export const CITIES_JSON = `${CLOUDFRONT_PREFIX}/cities.json`;
export const STATES_CITIES_JSON = `${CLOUDFRONT_BASE}/states%2Bcities.json`;

export const COUNTRIES_STATES_CITIES_JSON = (countryId: number) => 
  `${CLOUDFRONT_BASE}/states-by-country/${countryId}.json`;

export const questionnaireNavigation = (location: Location<any>, navigate: NavigateFunction, survey: Survey, domain: Domain, topic: Topic, bestPractice: BestPractice, question: Question, assessment?: Assessment) => {
  const isAssessmentRoute = location.pathname.includes('/assessment/');
  const routeAssessmentId = isAssessmentRoute ? location.pathname.split('/')[2] : assessment?.id;

  let nextPath = `/questionnaire/${survey.id}/domain/${domain.id}/topic/${topic.id}/best-practice/${bestPractice.id}/question/${question.id}`;

  if (routeAssessmentId && isAssessmentRoute) {
    nextPath = `/assessment/${routeAssessmentId}${nextPath}`;
  }

  if (location.pathname !== nextPath) {
    navigate(nextPath, { replace: true });
  }
};
